import { render, staticRenderFns } from "./CustomerSelect.vue?vue&type=template&id=1f47dd8f&"
import script from "./CustomerSelect.vue?vue&type=script&lang=js&"
export * from "./CustomerSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f47dd8f')) {
      api.createRecord('1f47dd8f', component.options)
    } else {
      api.reload('1f47dd8f', component.options)
    }
    module.hot.accept("./CustomerSelect.vue?vue&type=template&id=1f47dd8f&", function () {
      api.rerender('1f47dd8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/invoices-active/CustomerSelect.vue"
export default component.exports